export default "__VITE_ASSET__BiYgFYCc__"